import { ActionIcon, Box, Button, Group, Stack, Tooltip } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import PhaseBar from './PhaseBar';
import { PHASES } from './phases';

export default function WizardFrame({
  stepIndex = 0,
  totalSteps = 0,
  primaryLabel,
  onPrimary,
  primaryDisabled = false,
  showBack = false,
  onBack,
  secondaryLabel,
  onSecondary,
  dangerLabel,
  onDanger,
  children,
  hideCta = false,
  showExit = false,
  onExit,
  currentPhaseKey,
  completedPhaseKeys,
  onPhaseClick,
  phases = PHASES,
  maxWidth = 560,
  backLabel = 'Back',
}) {
  const showPhaseBar = Boolean(currentPhaseKey) && Array.isArray(completedPhaseKeys);

  return (
    <Box
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        background: 'var(--aviary-canvas)',
        color: 'var(--aviary-ink)',
        position: 'relative',
      }}
    >
      {showExit && onExit && (
        <Box style={{ position: 'absolute', top: 16, right: 16, zIndex: 10 }}>
          <Tooltip label="Cancel setup" withArrow>
            <ActionIcon
              variant="subtle"
              color="gray"
              size={28}
              onClick={onExit}
              aria-label="Cancel setup"
            >
              <IconX size={16} />
            </ActionIcon>
          </Tooltip>
        </Box>
      )}

      <Box style={{ flex: 1, display: 'flex', justifyContent: 'center', padding: '40px 24px 120px' }}>
        <Stack gap="xl" style={{ width: '100%', maxWidth }}>
          {showPhaseBar ? (
            <PhaseBar
              phases={phases}
              currentKey={currentPhaseKey}
              completedKeys={completedPhaseKeys}
              onPhaseClick={onPhaseClick}
            />
          ) : (
            totalSteps > 0 && stepIndex > 0 && (
              <Group gap={8} justify="center">
                {Array.from({ length: totalSteps }).map((_, i) => {
                  const filled = i < stepIndex;
                  return (
                    <Box
                      key={i}
                      style={{
                        width: 10,
                        height: 10,
                        borderRadius: '50%',
                        background: filled
                          ? 'var(--mantine-color-sage-6)'
                          : 'var(--aviary-disabled)',
                        transition: 'background 150ms ease',
                      }}
                    />
                  );
                })}
              </Group>
            )
          )}

          <Box style={{ flex: 1 }}>{children}</Box>
        </Stack>
      </Box>

      {!hideCta && (primaryLabel || showBack || secondaryLabel || dangerLabel) && (
        <Box
          style={{
            position: 'sticky',
            bottom: 0,
            background: 'var(--aviary-canvas)',
            borderTop: '1px solid var(--aviary-disabled)',
            padding: '16px 24px',
          }}
        >
          <Group justify="space-between" maw={maxWidth} mx="auto" w="100%">
            <Group gap="sm">
              {showBack && (
                <Button variant="subtle" color="gray" onClick={onBack}>
                  {backLabel}
                </Button>
              )}
              {secondaryLabel && (
                <Button variant="light" color="sage" onClick={onSecondary}>
                  {secondaryLabel}
                </Button>
              )}
              {dangerLabel && (
                <Button variant="subtle" color="red" onClick={onDanger}>
                  {dangerLabel}
                </Button>
              )}
            </Group>
            {primaryLabel && (
              <Button
                color="sage"
                size="md"
                disabled={primaryDisabled}
                onClick={onPrimary}
              >
                {primaryLabel}
              </Button>
            )}
          </Group>
        </Box>
      )}
    </Box>
  );
}
